<div class="main-wrapper"
    [ngClass]="{'canvas-open': canvasControlsExpanded }">
    <context-message></context-message>
    <router-outlet>
    </router-outlet>
</div>